"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtelierItem = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const Block_1 = require("./Block");
const pixi_js_1 = require("pixi.js");
const checkmark_svg_1 = __importDefault(require("../../assets/svg/checkmark.svg"));
const Global_1 = require("../Global");
const colors_1 = require("../config/colors");
const ColorItem_1 = require("./ColorItem");
class AtelierItem extends Block_1.Block {
    constructor(app, group, item) {
        super(app);
        this.group = group;
        this.item = item;
        this.background = new ColorItem_1.ColorItem(this.app, this.sample, 0.14, true);
        this.check = pixi_js_1.Sprite.from(checkmark_svg_1.default);
        this.check.anchor.set(0.5);
        this.check.scale.set((0, Global_1.px)(0.1));
        this.check.visible = false;
        this.addChild(this.background);
        this.addChild(this.check);
        this.update();
    }
    select() {
        (0, Global_1.fade)(this.check, 1, 0.1).then();
    }
    deselect() {
        (0, Global_1.fade)(this.check, 0, 0.1).then();
    }
    update() {
        this.background.update();
        this.check.position.set(this.background.width / 2, this.background.height / 2);
    }
    get sample() {
        return colors_1.colors[this.item.value];
    }
    layout() {
        super.layout();
        this.update();
    }
}
exports.AtelierItem = AtelierItem;
